import { FC } from "react";

interface IRootChat {
  children: any;
}

const RootChat: FC<IRootChat> = ({ children }) => <>{children}</>;

export default RootChat;
